import { render } from "./final-evaluation.vue?vue&type=template&id=fe4d13f4"
import script from "./final-evaluation.vue?vue&type=script&lang=js"
export * from "./final-evaluation.vue?vue&type=script&lang=js"

import "./final-evaluation.vue?vue&type=style&index=0&id=fe4d13f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__